import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
// import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { RestSchemas } from '@/contexts/QueryProvider'
import { OrgProjectForm } from '../../Forms/OrgProjectForm'
import { MaintainProjectAdminsForm } from '../../Forms/MaintainProjectAdminsForm'
import { MaintainProjectLeadersForm } from '../../Forms/MaintainProjectLeadersForm'

type MessagesProjectsOrganisationProject = RestSchemas['Messages.Projects.OrganisationProject']

export function RowActionsMenu({ project }: { project: MessagesProjectsOrganisationProject }) {
  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <OrgProjectForm
            selectedOrganisationProject={project}
            sheetTitle={`${project.name} > Edit project`}
            sheetDescription="Edit the details of the project."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit project</DropdownMenuItem>}
          />
          <MaintainProjectAdminsForm
            selectedProject={project}
            sheetTitle={`${project.name} > Maintain admins`}
            sheetDescription="Edit the admins of the project."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain project admins</DropdownMenuItem>
            }
          />
          <MaintainProjectLeadersForm
            selectedProject={project}
            sheetTitle={`${project.name} > Maintain leaders`}
            sheetDescription="Edit the leaders of the project."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain project leaders</DropdownMenuItem>
            }
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
